<template>
    <div class="prepayment-list">
        <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
        <div class="manage-table">
            <avue-crud
                :option="prepaymentListConfig"
                :data="tableData"
                v-model="searchForm"
                :page.sync="page"
                :search.sync="searchForm"
                @search-reset="searchResets"
                @on-load="queryTableData"
                @search-change="searchChange"
                @sort-change="sortChange"
                @refresh-change="queryTableData"
                @selection-change="selectionChange"
            >
                <template slot="searchMenu" slot-scope="{ row }">
                    <el-button type="primary" @click="saveData(row)">保存</el-button>
                    <!-- <el-button type="primary"  @click="openFilter">
                        <a-icon type="filter" /> 高级筛选
                    </el-button> -->
                </template>

                <template #contractNameSearch>
                    <!-- 存在绑定ID时不可更改项目 -->
                    <CommonSelect
                        bindLabel="contractName"
                        bindKey="id"
                        bindValue="contractName"
                        dataUrl="bl/blcontractmanage/page"
                        methods="get"
                        dataMethod="params"
                        searchKey="contractName"
                        :initParam="contractParam"
                        :bindId="selectContractId?selectContractId:''"
                        @handleChange="setContractInfo"
                    />
                </template>

                <template slot="menuLeft">
                    <el-button
                        size="small"
                        type="primary"
                        @click="handleAdd()"
                        v-if="permission.prepayment_add"
                    >
                        申请提前还款
                    </el-button>
                    <el-button
                        type="danger"
                        size="small"
                        icon="el-icon-delete"
                        plain
                        v-if="permission.prepayment_delete"
                        @click.stop="handleDeletes()"
                        >删除
                    </el-button>
                    <el-button
                        size="small"
                        type="primary"
                        plain
                        @click="handleEdit()"
                        v-if="permission.prepayment_edit"
                    >
                        编辑
                    </el-button>
                    <!-- <el-button
                        size="small"
                        icon="el-icon-download"
                        @click="exportShow"
                    >导出数据
                    </el-button> -->
                </template>

                <template slot="contractName" slot-scope="{ row }">
                    <div class="project-name" @click="goDetail(row)">{{row.contractName}}</div>
                </template>

            </avue-crud>
        </div>

        <SelectPerson
            ref="selectperson"
            :checkUserList="checkUserList"
            :isOnly="true"
            :clear="false"
            @setPeople="setPeople"
        />

        <ExportData ref="exportData" @exportDownload="exportDownload" />
    </div>
</template>
<script>
import {
  prepaymentListConfig,
} from "./prepaymentConfig.js";
import {queryPrepaymentList, prepaymentDelete} from "@/api/factoring/factoring"
import { downLoadTemplate } from "@/router/downLoadTem";
import CommonSelect from "@/components/commonSelect/commonSelect"
import TableList from "@/components/tableListComponents/table";
import TagsCloud from "@/components/TagsCloud/TagsCloud"
import ExportData from "@/components/exportData/exportData"
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import { mapGetters } from "vuex";
import list from "@/mixins/list.js"
import workFlow from '@/mixins/workFlow'
export default {
    name: "PrepaymentList",
    mixins: [list, workFlow],
    data() {
        return {
            exportApi: '',
            tableData: [],
            checkUserList: [],
            selectionList: [],
            prepaymentListConfig: prepaymentListConfig(),
            page: {
                currentPage: 1,
                total: 0,
                layout: "total,pager,prev, next",
                background: false,
                pageSize: 10,
            },
        }
    },
    components: {
        CommonSelect,
        TableList,
        TagsCloud,
        SelectPerson,
        SelectDepartment,
        ExportData
    },
    computed: {
        ...mapGetters(["userInfo","permission"]),
    },    
    activated() {
        this.queryTableData()
    },
    methods: {
        setContractInfo(data) {
            this.searchForm.conManageId = data.id
        },

        async queryTableData() {
            let params = {
                current: this.page.currentPage,
                size: this.page.pageSize,
                ...this.searchForm                
            }
            let res = await queryPrepaymentList(params)
            if(res.data.code == 200) {
                this.tableData = res.data.data.records
                this.page.total = res.data.data.total              
            } else {
                this.$message.error(res.data.msg)
            }
        },

        selectionChange(data) {
            this.selectionList = data
        },

        handleAdd() {
            this.$router.push({
                path: '/factoring/prepayment/addPrepayment'
            })            
        },

        handleEdit() {
            if(this.selectionList.length > 1){
                this.$message.error('只能选择一条数据进行编辑')
            } else if(this.selectionList.length == 1){
                let data = this.selectionList[0]
                if(data.auditStatus == 0) {
                    if(data.managerUser == this.userInfo.user_id || data.assistUser == this.userInfo.user_id){
                        this.$router.push({
                            path: `/factoring/prepayment/editPrepayment/${data.id}`
                        })
                    }else {
                        this.$message.warning('您暂无权限对该条数据进行编辑')
                    }
                }else {
                    this.$message.warning('该条数据已提交审核无法编辑')
                }
            }else {
                this.$message.error('请选择一条数据进行编辑')
            }            
        },
        
        searchResets() {
            this.searchForm = {}
            this.queryTableData()
        },

        goDetail(data) {
            this.$router.push({
                path: `/factoring/prepayment/prepaymentDetail/${data.id}`
            })
        },

        async handleDeletes() {
        let self = this
            let startDelete = () => {
                self.$confirm('确定删除选择的数据?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    self.deleteData()
                }).catch(() => {
                    self.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
            if(this.selectionList.length > 1){
                this.$message.error('只能选择一条数据进行删除')
            } else if(this.selectionList.length == 1){
                if(this.selectionList[0].managerUser == this.userInfo.user_id || this.selectionList[0].assistUser == this.userInfo.user_id){
                    let data = this.selectionList[0]
                    if(data.flowableId != '' && data.auditStatus == 1) {
                        // 获取流程数据
                        await this.queryFlowData(data.flowableId)
                        let presentFlow = this.flowData[this.flowData.length - 1]
                        if(this.processDetail.flow[2].historyActivityId == presentFlow.historyActivityId) {
                            startDelete()
                        }else {
                            this.$message.error('流程审批中不能删除')
                        }
                    }else {
                        // 直接弹框提示
                        startDelete()
                    }
                } else {
                    this.$message.error('您没有权限删除此条数据')
                }
            }else{
                this.$message.error('请选择数据进行删除')
            }
        },

        // 删除参数ids 提取this.selectionList中的id用,隔开成字符串
        async deleteData() {
            let ids = this.selectionList.map((item) => {
                return item.id
            })
            let res = await prepaymentDelete({ids: ids.join(',')})
            if(res.data.code == 200){
                this.$message.success('删除成功')
                // 刷新列表
                this.queryTableData()
            }
        },        

    }
}
</script>
<style lang="scss" scoped>
.prepayment-list{
  /deep/.el-table .cell  {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .manage-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name{
    // overflow: hidden;
    white-space: normal;
    // text-overflow: ellipsis;
    color: #409EFF;
  }
  .project-name:hover{
    color: #409EFF;
    cursor: pointer;
  }    
}
</style>